module.exports = __webpack_public_path__ + "img/9788954638234.474aaedb.jpg";